import { Container } from '@mui/material'
import { withStyles } from '@mui/styles'

export const AntContainerHead = withStyles(() => ({
    root: {
        paddingRight: 35,
        paddingLeft: 35,
        margin: 0,
        boxSizing: 'border-box',
        minWidth: 340,
        display: 'flex',
        flexDirection: 'row',
    },
    disableGutters: {
        padding: 0,
    },
}))(Container)

export const AntContainer = withStyles(() => ({
    root: {
        padding: 35,
        margin: 0,
        boxSizing: 'border-box',
        minWidth: 340,
    },
    disableGutters: {
        padding: 0,
    },
}))(Container)
